import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomSelect from '../../../Forms/Element/CustomSelect';
import axiosInstance from '../../../../../services/AxiosInstance';
import Api from '../../../../../constants/Api';

/**
 * Componente responsável por listar os grupos.
 */
const GroupSelect = (props) => {

  const { t } = useTranslation();
  const [entities, setEntities] = useState([]);

  useEffect(() => {
    
    function findAll() {
      setEntities([]);

      axiosInstance.get(Api.identity.group)
        .then(response => {
          let entities = [];

          for (var i = 0; i < response.data.length; i++) {
            entities.push(
              {
                value: response.data[i].id,
                label: response.data[i].name
              }
            );

            setEntities(entities);
          }
        });
    }

    findAll();
  }, []);

  return (
    <CustomSelect options={entities} value={props.value} onChange={props.onChange} isClearable isDisabled={props.isDisabled}  placeholder={t("select")} />
  )
}

export default GroupSelect;